export const ACCOUNT_RELATIONSHIP = {
  OWNER: 'owner',
  SHARED: 'shared',
};

export const ACCOUNT_RELATIONSHIP_LABEL = {
  [ACCOUNT_RELATIONSHIP.OWNER]: 'Sua conta',
  [ACCOUNT_RELATIONSHIP.SHARED]: 'Compartilhada com você',
};

export const ACCESSIBLE_ACCOUNTS_QUERY_KEY = ['accessible-accounts'];

export const ACCOUNT_DETAILS_RELATIONSHIP_LABEL = {
  [ACCOUNT_RELATIONSHIP.OWNER]: 'Titular',
  [ACCOUNT_RELATIONSHIP.SHARED]: 'Compartilhada com você',
};

export const ACCOUNT_DETAILS_QUERY_KEY = 'account-details';
